import dayjs, { storeTimeZone, toStoreTime } from "utils/dayjs";
import { storeTodayYmd, toStoreDay } from "utils/date";

// THE FORM'S PREVIEW of the dates FiscalYearService decides. Display only: the server works out the
// stored instants itself, and these two mirror its EndDayFor and TitleFor rule for rule.

/** A 12-month year's last day: the day before the same date next year. 29 Feb → 28 Feb. */
export const endDayFor = (start) => dayjs(start).add(1, "year").subtract(1, "day");

/** "Fiscal Year 2026" inside one calendar year, else "Fiscal Year 2023 - 2026". */
export const titleFor = (start, end) => {
  const from = dayjs(start).year();
  const to = dayjs(end).year();
  return from === to ? `Fiscal Year ${from}` : `Fiscal Year ${from} - ${to}`;
};

// "Has this fiscal year reached its last day?" - asked on the SHOP's calendar.
//
// FyAlert and FyAction each compared the year end with dayjs() - the viewer's own clock - so an
// owner abroad saw the "please close the fiscal year" prompt a day early or late. Both read this
// one helper instead, the same store-zone rule toRangeStartUtc/toRangeEndUtc follow.
export const isFiscalYearEndDue = (fyEndDate) => {
  if (!fyEndDate) return false;

  let today;
  try {
    today = dayjs().tz(storeTimeZone());
  } catch {
    today = dayjs();
  }

  return toStoreTime(fyEndDate).format("YYYY-MM-DD") <= today.format("YYYY-MM-DD");
};

// The default "From" day of the accounting reports (Trial Balance, P&L, General Ledger): the first
// day of the company's OPEN fiscal year, as a plain calendar day for InputDate.
//
// They used to default to 1 January. A company whose year runs Oct-Sep then opened every report
// across two fiscal years — mixing last year's closed income and expenses into this year's. Falls
// back to 1 January of the shop's year when no fiscal year is open, or when the open one has not
// started yet (a report From in the future is never what anyone wants).
export const fiscalYearStartDay = (settings) => {
  const today = toStoreDay(storeTodayYmd());
  const fyStart = settings?.fyStartDate ? toStoreDay(settings.fyStartDate) : null;
  return fyStart && fyStart.isValid() && !fyStart.isAfter(today) ? fyStart : today.startOf("year");
};

// Today on the shop's calendar, as a plain calendar day for InputDate.
export const storeToday = () => toStoreDay(storeTodayYmd());
